import { doesFocusableExist, setFocus } from "@noriginmedia/norigin-spatial-navigation";
import { EPG_CONTENT_FOCUS_KEY, FIRST_EVENT_KEY, SECTION_TYPES } from "../../constants/event";

// Header controls in priority order: Search first, the marketing button only as a fallback
const HEADER_FOCUS_KEYS = ["SEARCH_BUTTON", "MARKETING_BUTTON"];

// Does the row have elements? (live events can have no elements)
const isValidRow = (row) => row?.render && Array.isArray(row.items) && row.items.length > 0;

// Must match the focusKey each card registers with (see EPG*Card.js)
const getItemFocusKey = (row, item, index) => {
    switch (row.rowType) {
        case SECTION_TYPES.PARTNERS:
            return `partner-${row.rowId}-${index}`;
        case SECTION_TYPES.EVENTS:
            return `${row.rowType}-${row.rowId}-${item.id}`;
        default:
            return `${row.rowType}-${row.rowId}-${index}`;
    }
};

const findFocusKey = (rows) => {
    for (const row of rows) {
        for (let i = 0; i < row.items.length; i++) {
            const focusKey = getItemFocusKey(row, row.items[i], i);
            if (doesFocusableExist(focusKey)) return focusKey;
        }
    }
    return null;
};

export const getFirstAvailableFocusKey = (rowsData) => {
    const availableRows = rowsData?.filter(isValidRow) || [];
    return findFocusKey(availableRows);
};

export const safeSetFocus = (focusKey) => {
    if (!focusKey) return;

    if (doesFocusableExist(focusKey)) {
        setFocus(focusKey);
    }
};

export const getEPGFirstFocusKey = (rowsData) => {
    const headerKey = HEADER_FOCUS_KEYS.find(doesFocusableExist);
    if (headerKey) return headerKey;

    // Get the first available
    const focusKey = getFirstAvailableFocusKey(rowsData);
    if (focusKey) return focusKey;

    // Fallback to first live event
    if (doesFocusableExist(FIRST_EVENT_KEY)) {
        return FIRST_EVENT_KEY;
    }

    // Last resort: focusing the container makes norigin pick its first focusable child,
    // or keep focus on the container itself so the D-pad can still navigate out of it
    if (doesFocusableExist(EPG_CONTENT_FOCUS_KEY)) {
        return EPG_CONTENT_FOCUS_KEY;
    }

    return null;
};
